<script>
    import BgSelectReferenceModalView from "@/components/BgSelectReferenceModalView.vue";

    export default {
        components: {
            BgSelectReferenceModalView,
        },

        props: {
            show: {
                type: Boolean,
                required: true,
            },
            referenceId: {
                type: Number,
                required: true,
            },
            relationObject: {
                type: String,
                required: true,
            },
            relationLabel: {
                type: String,
                required: true,
            },
            relationTab: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                visible: false,
            }
        },

        watch: {
            show: function (newValue) {
                this.visible = newValue
            },
        },
    }
</script>

<template>
    <b-modal @close="$emit('close')" :active.sync="visible" has-modal-card custom-class="bg-upload__modal">
        <div class="card">
            <div class="card-content">
                <div class="columns bg-upload__grid">
                    <div class="column">
                        <bg-select-reference-modal-view @search="value => $emit('search', value)" :referenceId="referenceId" :relationObject="relationObject" :relationLabel="relationLabel" :relationTab="relationTab"/>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
